<script>
  export default {
    name: 'app-store-featured'
  }
</script>

<template>
  <section class="featured">
    <b-container>
      <b-row>
        <b-col cols="2" class="text-center">
          <img src="/img/apps/weather_icon.png" alt="Weather Channel" class="icon"/>
          <b-button variant="primary" type="button">Add App</b-button>
        </b-col>
        <b-col cols="6">
          <h6>Featured App</h6>
          <h3>Weather Channel</h3>
          <h5>by Rich Apps</h5>
          <p>
            This app allows you to list all the rooms or offices in a building, group them by floors, add logos and
            update everything on the fly, so that your visitors are always pointed in the right direction.
          </p>
        </b-col>
        <b-col cols="4">
          <img src="/img/apps/app_preview.png" alt="Preview" class="preview drop-shadow"/>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<style src="./AppStoreFeatured.scss" lang="scss" scoped></style>
